import { ReactNode, useEffect, useMemo, useRef, useState } from "react"
import { twJoin } from "tailwind-merge"

type CollapseProps = {
  children: ReactNode
  isOpen?: boolean
  onToggle?: () => void
  className?: string
  title: ReactNode | (({ isOpen }: { isOpen: boolean }) => ReactNode)
  iconFunc: ({ isOpen }: { isOpen: boolean }) => ReactNode
}

export const Collapse = ({ title, iconFunc, children, isOpen, onToggle, className }: CollapseProps) => {
  const contentRef = useRef<HTMLDivElement>(null)
  const [open, setOpen] = useState<boolean>(false)
  const [height, setHeight] = useState(0)

  const isOpenMemo = useMemo(() => {
    if (onToggle) {
      return isOpen
    }

    return open
  }, [open, isOpen, onToggle])

  useEffect(() => {
    if (isOpenMemo && contentRef.current) {
      setHeight(contentRef.current.scrollHeight)
    } else {
      setHeight(0)
    }
  }, [isOpenMemo])

  return (
    <div className={twJoin("collapse-wrapper", className, "overflow-hidden")}>
      <button
        className={twJoin("collapse-button", "flex flex-row justify-between items-center w-full")}
        onClick={
          onToggle
            ? onToggle
            : () => {
                setOpen((prevState) => !prevState)
              }
        }
      >
        {typeof title === "function" ? title({ isOpen: isOpenMemo }) : title}
        {iconFunc({ isOpen: isOpenMemo })}
      </button>
      <div
        className={twJoin("collapse-child-container", "overflow-hidden transition-[height] duration-300")}
        style={{ height: isOpenMemo ? `${height}px` : "0px" }}
      >
        <div
          ref={contentRef}
          className={"collapse-content"}
        >
          {children}
        </div>
      </div>
    </div>
  )
}
